export default __webpack_public_path__ + "ba55b931fd7b39be0997de99bd6cb005.png";